/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["ky.","kp.","aamulla","ap.","ip.","illalla","yöllä"],["keskiyöllä","keskip.","aamulla","aamup.","iltap.","illalla","yöllä"],["keskiyöllä","keskipäivällä","aamulla","aamupäivällä","iltapäivällä","illalla","yöllä"]],[["ky.","kp.","aamu","ap.","ip.","ilta","yö"],["keskiyö","keskip.","aamu","aamup.","iltap.","ilta","yö"],["keskiyö","keskipäivä","aamu","aamupäivä","iltapäivä","ilta","yö"]],["00:00","12:00",["05:00","10:00"],["10:00","12:00"],["12:00","18:00"],["18:00","23:00"],["23:00","05:00"]]];
